const ResolutionLabels = {
    1: '1',
    0.75: '0.75',
    0.5: '0.5',
    0.25: '0.25',
    0.125: '0.125'
};

const MissionProviderRoleEnum = {
    licensor: 1,
    producer: 2,
    host: 3,
    processor: 4
};

const CollectionCategoryEnum = {
    ortho_photo_mosaic: 1,
    oblique_photo_mosaic: 2,
    terrain_mosaic: 3,
    streetview: 4,
    pointcloud: 5,
    ortho_photo_tileset: 6,
    oblique_photo_tileset: 7,
    terrain_tileset: 8,
    web_service: 9,
}

const CreateAssetRequestTypeEnum = {
    create_cog_asset_from_tiles_in_directory: 1,
    create_cog_assets_for_tiles_in_directory: 2,
    create_streetview_assets_for_images_in_directory: 3
};

const JobStatusEnum = {
    not_started: 1,
    running: 2,
    failed: 3,
    completed: 4
};

const CollectionCardinalDirectionEnum = {
    Nadir: 0,
    North: 1,
    East: 2,
    South: 3,
    West: 4
};

const BatchJobStorageEnum = {
    '1 TB': 1,
    '2 TB': 2,
    '3 TB': 3,
    '4 TB': 4,
    '10 TB': 10,
    '16 TB': 16,
}

const BatchJobVCPUsEnum = {
    '2': 2,
    '8': 8,
    '16': 16,
    '32': 32,
}

const GeoAIFeatureTypesEnum = {
    'Building': 1,
    'Car': 2,
    'Ship': 3,
    'Pool': 4,
    'Solar Panel': 5,
    'change_detection': 6,
    'Tree Canopy': 7
}

const UserPlanEnum = {
    Freemium: 1,
    Starter: 2,
    Professional: 3,
    Enterprise: 4
}

exports.UserPlanEnum = UserPlanEnum;
exports.JobStatusEnum = JobStatusEnum;
exports.ResolutionLabels = ResolutionLabels;
exports.BatchJobVCPUsEnum = BatchJobVCPUsEnum;
exports.BatchJobStorageEnum = BatchJobStorageEnum;
exports.GeoAIFeatureTypesEnum = GeoAIFeatureTypesEnum;
exports.CollectionCategoryEnum = CollectionCategoryEnum;
exports.MissionProviderRoleEnum = MissionProviderRoleEnum;
exports.CreateAssetRequestTypeEnum = CreateAssetRequestTypeEnum;
exports.CollectionCardinalDirectionEnum = CollectionCardinalDirectionEnum;